<template>
  <section class="labs-experience-featured">
    <div class="labs-experience-featured__header">
      <div class="labs-experience-featured__header__title">
        {{ titleText }}
      </div>
      <div class="labs-experience-featured__header__collections-link">
        <router-link
          :to="{ name: 'collection-all' }"
          class="labs-experience-featured__header__collections-link-btn btn btn--secondary"
        >
          <span>
            See all
            <span v-if="getWindowWidth() > 768">collections</span>
          </span>
        </router-link>
      </div>
    </div>
    <div class="labs-experience-featured__cards-list">
      <LabsCollectionCard
        v-for="collectionFeatured in collectionsFeatured"
        :key="collectionFeatured.id"
        :collection="collectionFeatured"
        :learningAreasAllowed="availableLearningAreas"
        :showTooltips="false"
        class="labs-experience-featured__cards-list__item"
      />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import LabsCollectionCard from '@/components/lab-experience/LabsCollectionCard.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'LabsCollectionsFeatured',
  components: {
    LabsCollectionCard,
  },
  inject: ['getWindowWidth'],
  props: {
    collectionsFeatured: {
      type: Array,
      required: true,
    },
    isHomepage: {
      type: Boolean,
      required: false,
      default: false,
    },
    viewStyle: {
      type: String,
      required: false,
      default: 'tile',
    },
  },
  computed: {
    ...mapState({
      availablePasses: state => state.auth.available_passes,
    }),
    ...mapGetters({
      isLabExperienceUser: 'auth/isLabExperienceUser',
      isSkillDiveB2CUser: 'auth/isSkillDiveB2CUser',
      isSkillDiveB2BUser: 'auth/isSkillDiveB2BUser',
      labExperienceEnhance: 'featureFlags/labExperienceEnhance',
    }),
    titleText() {
      return this.isHomepage
        ? 'We have featured collections for you'
        : 'More collections you might like'
    },
    availableLearningAreas() {
      if (this.isSkillDiveB2CUser) {
        return this.availablePasses
          .filter(
            pass => CONSTANTS.SKILL_DIVE_B2C_PASSES_LEARNING_AREAS[pass.id]
          )
          .map(pass => CONSTANTS.SKILL_DIVE_B2C_PASSES_LEARNING_AREAS[pass.id])
      } else if (this.isSkillDiveB2BUser || this.labExperienceEnhance) {
        return CONSTANTS.LAB_EXPERIENCE.LEARNING_AREAS
      }
      return []
    },
  },
}
</script>

<style lang="scss" scoped>
.labs-experience-featured {
  display: flex;
  flex-wrap: wrap;
  color: var(--white);

  &__header {
    display: flex;
    gap: 10px;
    justify-content: space-between;
    width: 100%;

    &__title {
      font-size: rem(18px);
      font-weight: 500;
      line-height: rem(24px);
      text-align: left;
      margin-bottom: 30px;

      @include tablet {
        font-size: rem(24px);
        line-height: rem(32px);
        font-weight: 450;
        margin-bottom: 60px;
      }
    }

    &__collections {
      &-link-btn {
        padding: 8px 16px;

        @include mobile {
          padding: 12px 24px;
        }
      }
    }
  }
  &__cards-list {
    display: flex;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    column-gap: 10px;
    overflow: auto;
    white-space: nowrap;
    padding-bottom: 50px;
    @include desktop {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;

      white-space: unset;
      overflow: auto;
      justify-content: center;
    }
  }
}
</style>
